<template>
<div class="ti">
  <div>
    <el-button size="mini" type="primary text2"  @click="modals">添加管家角色</el-button>
    <!-- <el-select v-model="value" filterable placeholder="请选择组织" class="kuan" v-if="userJid[0]['id']==4003001">
      <el-option
        key=""
        label="全部"
        value="">
      </el-option>
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.company_name"
        :value="item.id">
      </el-option>
    </el-select> -->
    <el-input size="mini" class="search" placeholder="请输入搜索名称" v-model="search" clearable></el-input>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">管家角色名称</th>
            <th class="text-left">权限</th>
            <th class="text-left">跨权</th>
            <th class="text-left">小程序管家电话</th>
            <th class="text-left">日期</th>
            <th class="text-left">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <td >{{item.name}}</td>
            <td ><span v-if="item.radio == 1">操作和查看权限</span><span v-if="item.radio == 2">查看权限</span><span v-if="item.radio == 3">没有权限</span></td>
            <td ><span v-if="item.radio2 == 1">本架构项目权限</span><span v-if="item.radio2 == 2">本架构和下级架构权限</span><span v-if="item.radio2 == 3">没有权限</span></td>
            <td ><span v-if="item.radio1 == 1">显示</span><span v-if="item.radio1 == 2">不显示</span></td>
            <td >{{item.date}}</td>
            <td v-if="item.caoz == 1" class="cdj_td">
              <div style="color: #1867c0;cursor: pointer;" @click="xiugai( item.id )">修改</div>
              <div  style="color: red;margin-left: 5px;cursor: pointer;" @click="del( item.id )">删除</div>
            </td>
            <td v-else>无</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <Modal
        v-model="modal1"
        :ok-text="anxiu"
        width="800"
        title="编辑"
        @on-ok="ok">
        <div>
          <el-form  label-width="100px" :model="dades">
            <!-- <el-form-item label="组织" :rules="[{required: true}]">
              <el-select v-model="dades.company_id" filterable placeholder="请选择" v-if="cs == 2" disabled @change="changesa(dades.company_id)">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.company_name"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="dades.company_id" filterable placeholder="请选择" v-else @change="changesa(dades.company_id)">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.company_name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="角色名称" :rules="[{required: true}]">
              <el-input v-model="dades.name"></el-input>
            </el-form-item>
            <el-form-item label="角色权限" :rules="[{required: true}]">
                <el-checkbox-group v-model="dades.checkList">
                    <el-radio v-model="dades.radio" label="1">操作和查看权限</el-radio>
                    <el-radio v-model="dades.radio" label="2">查看权限</el-radio>
                    <el-radio v-model="dades.radio" label="3">没有权限</el-radio>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="跨级权限" :rules="[{required: true}]">
                <el-radio v-model="dades.radio2" label="1">本架构项目权限</el-radio>
                <el-radio v-model="dades.radio2" label="2">本架构和下级架构权限</el-radio>
                <el-radio v-model="dades.radio2" label="3">没有权限</el-radio>
            </el-form-item>
            <el-form-item label="小程序管家" :rules="[{required: true}]">
                <el-radio v-model="dades.radio1" label="1">前端展示联系方式</el-radio>
                <el-radio v-model="dades.radio1" label="2">前端不显示联系方式</el-radio>
            </el-form-item>
          </el-form>
        </div>
    </Modal>
</div>

</template>

<script>
export default {
  name: 'UserBulterRole',
  data () {
    return {
      url:'',
      url1:'',
      img:[],
      defaultcheckedkeys:[],
      defaultcheckedkeyssa:[],
      dades: {
        id:'',
        name:'',
        radio:"2",
        radio1:"2",
        radio2:'1'
      },
       options: [
        {
          value: '',
          label: ''
        },],
        options1: [
        {
          value: '',
          label: ''
        },],
        opdade:[],
      options2:[],
      value: '',
      value1:'',
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      modal1: false,
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.url = this.$myhttp.defaults.baseURL + "/admin/posts";
    this.url1 = this.$myhttp.defaults.baseURL;
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    ERP.showLoading()
    this.$Loading.start();
    this.$myhttp.get('admin/getcompanygshu?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // this.value1 = backdata.data[0];//开启不查全部
        this.value1 = 0;
        this.$myhttp.get('admin/userButleruser?id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
          ERP.hideLoading()
        });
    });
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
        this.options1 = backdata.data[1];
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //监听选择组织改变归属
    changesa(e){
       this.$Loading.start();
      this.$myhttp.get('admin/getuserOwner?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
        this.opdade=backdata.data;
        this.$Loading.finish();
       this.$forceUpdate();
      });

    },
    //保存
    ok(){
      if(this.dades.name == ""){
        this.$Message.error('角色名称不能为空!');
        return false;
      }
      this.$Loading.start();
      this.$myhttp.post('admin/userButleruserAdd',this.dades,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[0] == 1){
            this.$myhttp.get('admin/userButleruser?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
            });
            this.$Message.success(backdata.data[1]);
            this.dades={
              id:'',
              name:'',
              type:'',
              radio:"2",
              radio1:"2",
              radio2:"2",
            };
            this.img = [];
          }else{
            this.$Message.error('编辑失败!');
          }
          this.$Loading.finish();
      });
    },
    //弹窗添加
    modals(){
      this.anxiu = "保存";
      if(this.dades.id){
        this.dades={
          id:'',
          name:'',
          type:'',
          radio:"2",
          radio1:"2",
          radio2:"2",
        };
        this.img = [];
      }
      //加载公司权限列表
       this.$Loading.start();
      var login = window.localStorage.getItem('login');
      this.$myhttp.get('admin/getJlist?login='+login,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[1] == 2){
              this.data =  backdata.data[0];
          }
          this.cs = backdata.data[1];
          this.dades.company_id=backdata.data[3];
          if(this.dades.company_id){
             this.$myhttp.get('admin/getuserOwner?id='+this.dades.company_id,{
            'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
              this.opdade=backdata.data;
              this.$Loading.finish();
              this.$forceUpdate();
            });
          }
          this.$Loading.finish();
      });
      this.modal1 = true;
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/userButleruser?id='+ e + '&search='+ this.search +'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      ERP.showLoading()
      this.$Loading.start();
      this.$myhttp.get('admin/userButleruser?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //修改查询
    xiugai(e){
      this.$Loading.start();
      this.anxiu="修改";
      this.$myhttp.get('admin/userButleruserUpdate?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.dades = backdata.data[0][0];
          this.cs = backdata.data[1];
          this.$Loading.finish();
          this.$forceUpdate();
          this.modal1 = true;
      });
    },
    //删除
    del(e){
      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$Loading.start();
          this.$myhttp.post('admin/userButleruserDelete',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 200){
                this.dela = true;
                var t = Date.parse(new Date()) / 1000;//时间戳
                this.$myhttp.get('admin/userButleruser?id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
                  'Content-Type': 'application/json'
                  }).then(backdata=>{ // 异步执行成功后
                    this.desserts = backdata.data[0];
                    this.total = backdata.data[1];
                    this.page = backdata.data[2];
                    this.$Loading.finish();
                    this.$Message.success('删除成功!');
                  });
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(247, 243, 243);
  font-size: 20px;
  margin-top: 3%;
}
</style>
<style>
.el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    line-height: 100px;
    vertical-align: top;
}
.el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    margin: 0 8px 8px 0;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/Butleruser.vue